import { AiStates } from "@/types/ai.ts";
import type { FC } from "react";
import { styled } from "@linaria/react";
import { t } from "@/themes/theme";

interface SwitchProps {
  state: boolean;
  callback: (newState: boolean) => void;
  aiMode?: AiStates;
}

const Button = styled.button`
  display: flex;
  align-items: center;

  border: none;
  background-color: ${t.switchOffColor};
  border-radius: 9999px;
  padding: 3px;

  width: 2rem;
  min-width: 2rem;
  height: 1.2rem;

  &[data-on="true"] {
    background-color: ${t.switchOnColor};
  }

  &[data-ai="true"] {
    background: ${t.brandAiBackground};
  }
`;

const CosmeticCircle = styled.div`
  border-radius: 9999px;
  background-color: white;

  transition: all 500ms linear(0, 0.06, 0.25, 0.56, 1 36%, 0.88, 0.81, 0.88, 1 73%, 0.95, 1);

  &[data-on="true"] {
    transform: translateX(0.8rem);
  }

  width: 13px;
  height: 13px;
`;

export const Switch: FC<SwitchProps> = ({ state, callback, aiMode }) => {
  return (
    <Button
      data-on={state}
      data-ai={aiMode === AiStates.on}
      onClick={() => {
        callback(!state);
      }}
    >
      <CosmeticCircle data-on={state} />
    </Button>
  );
};
